import HTTP from '@/api/HTTP';
import generalTransformer from '@/services/general/filters/serverTableDataTransformer';

const URL_BASE = 'gescom/OrdreTravailAffichage/';

export async function getAll(serverTabledata) {
  const inputServer = generalTransformer(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function genererOrdreTravail(data) {
  const response = await HTTP.post(URL_BASE + 'GenererAsync', data);
  return response;
}

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function update(ordreTravail) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', ordreTravail);
  return response;
}

export async function deleteOt(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: id } });
  return response;
}

export async function getOdresTravailsOfCommande(id) {
  const response = await HTTP.post(URL_BASE + 'PGetAllFromCommandeAsync', { id: id });
  return response;
}

export async function addTfsAsync(data) {
  const response = await HTTP.post(URL_BASE + 'AddTfsAsync', data);
  return response;
}

export async function cloture(id) {
  const response = await HTTP.post(URL_BASE + 'ClotureAsync', { id });
  return response;
}

export async function reactiver(id) {
  const response = await HTTP.post(URL_BASE + 'ReactiverAsync', { id });
  return response;
}

export async function deleteAllOt(ids) {
  const response = await HTTP.post(URL_BASE + 'PDeleteAllAsync', { otIds: ids });
  return response;
}
